const omittedStopsReport = {
    namespaced: true,
    state: {
        omittedStopsReportList: []
    },
    mutations: {
        updateOmittedStopsReportList(state, newList) {
            state.omittedStopsReportList = newList;
        }
    },
    actions: {
        getOmittedStopsReportList(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/omittedstopsreport/getOmittedStopsReportList', { params: data })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateOmittedStopsReportList', response.data);
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        exportXLS(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/omittedstopsreport/exportXLS', { params: data, responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/xlsx' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = 'omitted_stops_report.xlsx'
                        link.click()
                        URL.revokeObjectURL(link.href)

                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        }
    }
}
export default omittedStopsReport;